<template>
    <div class="biz-internal-auth parent-frame">
        <div class="biz-internal-auth-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss">
    .biz-internal-auth{
        position: relative;
        .biz-internal-auth-wrap{
            padding: 0 30px 30px 30px;
            width:  calc(1180px - 40px);
        }
    }
    @media screen and (max-width: 1280px){
        // .biz-internal-auth{
        //     .biz-internal-auth-wrap{
        //         padding: 30px;
        //     }
        // }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/internalAuth/internalAuthFrame.vue